export default "__VITE_ASSET__BEBNtnuQ__"